import React from 'react'

export const Sparkline = ({
  data,
  className,
  color = 'currentColor',
  width = 80,
  height = 28,
  fill = false,
}) => {
  if (!data || data.length === 0) {
    return null
  }

  const max = Math.max(...data)
  const min = Math.min(...data)
  const pad = 2
  const points = data.map((value, index) => {
    const x = pad + (index / Math.max(1, data.length - 1)) * (width - 2 * pad)
    const y = pad + (1 - (value - min) / Math.max(1, max - min)) * (height - 2 * pad)
    return [x, y]
  })
  const linePath = points
    .map(
      (point, index) => `${(index === 0 ? 'M' : 'L') + point[0].toFixed(1)},${point[1].toFixed(1)}`
    )
    .join(' ')
  const areaPath = `${linePath} L${points[points.length - 1][0].toFixed(1)},${height - pad} L${points[0][0].toFixed(
    1
  )},${height - pad} Z`

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{ overflow: 'visible' }}
    >
      {fill && <path d={areaPath} fill={color} fillOpacity="0.12" />}
      <path
        d={linePath}
        fill="none"
        stroke={color}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={points[points.length - 1][0]}
        cy={points[points.length - 1][1]}
        r="2.5"
        fill={color}
      />
    </svg>
  )
}
